import React, { useEffect, useState } from 'react';
import { useI18n } from 'react-simple-i18n';
import folk from '../assets/img/4con.png';
import folk2 from '../assets/convo.png';
import blocks from '../assets/img/5.png';
import pins from '../assets/img/6.png';
import bulb from '../assets/img/7.png';
import qstn from '../assets/img/qstn.png';
import aaa from '../assets/img/7aaa.png';
import multiarrows from '../assets/img/multiarrows.png';
import bad from '../assets/img/7bad.png';
import { Link } from 'react-router-dom';
import FlipComponent from '../components/FlipComponent/FlipComponent';
import appstate, { getLocaledString } from '../appstate';
import itm1 from '../assets/img/stock/stock-3.jpeg';
import itm2 from '../assets/img/stock/stock-1.jpg';
import itm3 from '../assets/img/stock/stock-2.jpg';
import sss from '../assets/img/sss.png';
import ggg from '../assets/img/ldhy.webp';
import ModulesView from './modulesView';
import { MeasuresQuiz } from './measuresView';
import FullPageLoadingComponent from '../components/fullPageLoadingComponent';
import KeyOrgsView from './keyOrgsView';
import pxls1 from '../assets/img/stock/pxls1.webp';
import pxls2 from '../assets/img/stock/pxls2.jpg';
import pxls3 from '../assets/img/stock/pxls3.jpg';
import pxls4 from '../assets/img/stock/pxls4.jpg';
import pxls5 from '../assets/img/stock/pxls5.webp';
import pxls6 from '../assets/img/stock/pxls6.webp';
import pxls7 from '../assets/img/stock/pxls7.jpg';
import pxls8 from '../assets/img/stock/pxls8.jpg';

function MeasureSections(props: { type: number; activeSection: string }) {
	const { activeSection } = props;

	const sections = () => {
		if (appstate.currentLanguage() === 'slSI') {
			if (props.type === 1) {
				return [
					'Veščine vodstva',
					'Zaposlovanje in razvoj kadrov',
					'Nagrajevanje in napredovanje',
					'Skrbstveno delo',
					'Informiranje in komuniciranje',
					'Zadovoljstvo na delovnem mestu',
					'Delovni čas in organizacija dela',
				];
			} else {
				return [
					'Informiranje in komuniciranje',
					'Zadovoljstvo na delovnem mestu',
					'Delovni čas in organizacija dela',
				];
			}
		} else {
			if (props.type === 1) {
				return [
					'Leadership skills',
					'Recruitment and development of new personnel',
					'Care work',
					'Rewarding and promotion',
					'Communication',
					'Job satisfaction',
					'Work hours organization',
				];
			} else {
				return [
					'Communication',
					'Job satisfaction',
					'Work hours organization',
				];
			}
		}
	};

	const [slideOut, setSlideOut] = useState(false);

	console.log(activeSection);

	const getSectionContent = () => {
		if (appstate.currentLanguage() === 'slSI') {
			if (activeSection === 'Delovni čas in organizacija dela') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko zaposlenemu oziroma zaposleni omogoči:</b>\n' +
					'<ul>\n' +
					'    <li>fleksibilen delovni čas;</li>\n' +
					'    <li>drseči delovni čas;</li>\n' +
					'    <li>delo od doma;</li>\n' +
					'    <li>delo izven prostorov delodajalca;</li>\n' +
					'    <li>fleksibilno izmensko delo;</li>\n' +
					'    <li>možnost dela s skraj&scaron;anim delovnim časom;</li>\n' +
					'    <li>hibridno delo;</li>\n' +
					'    <li>pravico do odklopa.</li>\n' +
					'</ul>\n' +
					'<p><br></p>\n' +
					'<p>Na ravni oddelka ali podjetja se lahko vzpostavi delovna skupina za usklajevanje poklicnega in zasebnega življenja, ki bi bila zadolžena za konkretne akcije na tem področju, denimo glede božičnih in novoletnih zabav za otroke, družinskih piknikov, itd. Eden izmed osrednjih ciljev tak&scaron;ne skupine je tudi pomoč pri oblikovanju novih ukrepov na področju usklajevanja poklicnega in zasebnega življenja v sodelovanju z ostalimi zaposlenimi.</p>'
				);
			}

			if (activeSection === 'Informiranje in komuniciranje') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko:</b>\n' +
					'<ul>\n' +
					'    <li>pripravi informacijski izroček/letak za informiranje zaposlenih glede možnosti usklajevanja poklicnega in zasebnega življenja;</li>\n' +
					'    <li>na letni ravni izvede anketo med zaposlenimi o zadovoljstvu z možnostmi usklajevanja poklicnega in zasebnega življenja;</li>\n' +
					'    <li>področje usklajevanja poklicnega in zasebnega življenja uvede v letni razgovor z zaposlenimi;</li>\n' +
					'    <li>vzpostavi &rdquo;&scaron;katlo predlogov&rdquo; v podjetju, s katero bi skrbel za komuniciranje (ne)zadovoljstva zaposlenih.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Veščine vodstva') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko:</b>\n' +
					'<ul>\n' +
					'    <li>uvede sistem izobraževanja vodij na področju usklajevanja poklicnega in zasebnega življenja;</li>\n' +
					'    <li>krepi filozofijo/načela vodenja s poudarkom na usklajevanju poklicnega in zasebnega življenja;</li>\n' +
					'    <li>vodstvenim kadrom, ki se zaradi skrbstvenih obveznosti odločijo za skraj&scaron;an delovni čas omogoči, da ohranijo svoj položaj;</li>\n' +
					'    <li>pri letnem ocenjevanju vodij uvede kriterij uklajevanja poklicnega in zasebnega življenja in enakosti med spoloma;</li>\n' +
					'    <li>v etični kodeks organizacije uvede načelo enakosti med spoloma in usklajevanja poklicnega in zasebnega življenja.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Zaposlovanje in razvoj kadrov') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko:</b>\n' +
					'<ul>\n' +
					'    <li>v svojo organizacijsko kulturo uvede t. i. nepristransko zaposlovanje;</li>\n' +
					'    <li>sledi načelu spolne uravnoteženosti pri zaposlovanju novih kadrov;</li>\n' +
					'    <li>razvije primerne strategije za ponovno vključevanje zaposlenih po dalj&scaron;i odsotnosti;</li>\n' +
					'    <li>uvede načrtovanje kariernega razvoja zaposlenih;</li>\n' +
					'    <li>svojim zaposlenim omogoči določeno stopnjo avtonomije pri izobraževanju;</li>\n' +
					'    <li>naj pri letnih razgovorih uvede vidik usklajevanja poklicnega in zasebnega življenja;</li>\n' +
					'    <li>stremi k vzpostavljanju t. i. me&scaron;anih ekip;</li>\n' +
					'    <li>uvede psiholo&scaron;ko svetovanje in pomoč za svoje zaposlene;</li>\n' +
					'    <li>uvede delavnice in izobraževanja na področju spolnih stereotipov;</li>\n' +
					'    <li>s ciljem spodbujanja aktivnega očetovstva omogoči razgovor s kadrovsko službo in psihologom.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Nagrajevanje in napredovanje') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko:</b>\n' +
					'<ul>\n' +
					'    <li>razvije kulturo obdarovanja star&scaron;ev novorojenčkov;</li>\n' +
					'    <li>organizira aktivnosti, ki jih lahko koristijo zaposleni in njihovi družinski člani;</li>\n' +
					'    <li>uvede prispevek za star&scaron;e &scaron;olajočih otrok v obliki &scaron;tipendije;</li>\n' +
					'    <li>naj uvede posojila in finančno pomoč za zaposlene;</li>\n' +
					'    <li>sprejme ustrezen akt, s katerim bi na makro ravni opredelil možnosti nagrajevanja in stimulacij;</li>\n' +
					'    <li>pri vidiku napredovanja upo&scaron;teva načelo enakosti med spoloma in različne oblike skrbstvenih obveznosti zaposlenih.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Zadovoljstvo na delovnem mestu') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko:</b>\n' +
					'<ul>\n' +
					'    <li>uvede t. i. razvojno kavo za svoje zaposlene, katere cilj je povabiti zaposlene na kavo, pospremljeno z informiranjem in komuniciranjem;</li>\n' +
					'    <li>uvede sofinanciranje različnih aktivnosti zaposlenih v prostem času;</li>\n' +
					'    <li>uvede kotiček/sobo za druženje v organizaciji za zaposlene;</li>\n' +
					'    <li>uvede novoletno obdarovanje otrok zaposlenih;</li>\n' +
					'    <li>razvije kulturo obdarovanja star&scaron;ev novorjenčkov.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Skrbstveno delo') {
				return (
					'<b>Vodja (oziroma delodajalec) lahko:</b>\n' +
					'<ul>\n' +
					'    <li>organizira oziroma sofinancira različne oblike dnevnega varstva za otroke zaposlenih;</li>\n' +
					'    <li>vzpostavi ustrezne mehanizme, da lahko zaposleni za kraj&scaron;i čas ob posebnih okoli&scaron;činah na delovno mesto pripeljejo otroke;</li>\n' +
					'    <li>zaposlenim, ki imajo skrbstvene obveznosti, omogoči določeno kvoto ur, ki jih lahko za te namene koristijo brez nadome&scaron;čanja;</li>\n' +
					'    <li>uskladi dopust zaposlenih s &scaron;olskimi počitnicami;</li>\n' +
					'    <li>uvede dneve za druženje otrok zaposlenih, pri čemer naj poseben poudarek nameni otrokom mo&scaron;kih zaposlenih;</li>\n' +
					'    <li>spodbuja aktivno očetovstvo med svojimi zaposlenimi.</li>\n' +
					'</ul>'
				);
			}
		} else if (appstate.currentLanguage() === 'enUK') {
			if (activeSection === 'Veščine vodstva') {
				return (
					'<p><strong>Manager can:</strong></p>\n' +
					'<ul>\n' +
					'    <li>Introduces a system of training managers in the field of work-life balance;</li>\n' +
					'    <li>Reinforces management philosophy/principles with an emphasis on work-life balance;</li>\n' +
					'    <li>Enables management personnel, who decide to work reduced hours due to care obligations, to maintain their position;</li>\n' +
					"    <li>Introduces the principles of gender equality and work-life balance into the organization's code of ethics.</li>\n" +
					'</ul>'
				);
			}

			if (activeSection === 'Zaposlovanje in razvoj kadrov') {
				return (
					'<p><strong>Manager can:</strong></p>\n' +
					'<ul>\n' +
					'    <li>Introduces the so-called impartial recruitment;</li>\n' +
					'    <li>Follows the principle of gender balance when recruiting new personnel;</li>\n' +
					'    <li>Develops suitable strategies for the reintegration of employees after a long absence;</li>\n' +
					'    <li>Introduces employee career development planning;</li>\n' +
					'    <li>Allows their employees a certain degree of autonomy in choosing professional trainings;</li>\n' +
					'    <li>Strives to establish mixed working teams;</li>\n' +
					'    <li>Introduces psychological counseling and assistance for its employees;</li>\n' +
					'    <li>Introduces workshops and trainings in the field of gender stereotypes;</li>\n' +
					'    <li>With the aim of encouraging active fatherhood, allows an interview with the HR department and a psychologist.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Skrbstveno delo') {
				return (
					'<p><strong>Manager can:</strong></p>\n' +
					'<ul>\n' +
					"    <li>Organizes or co-finances various forms of day care for employees' children;</li>\n" +
					'    <li>Establishes appropriate mechanisms so that employees can bring children to the workplace for a short time under special circumstances;</li>\n' +
					'    <li>Gives a certain quota of hours that employees with special care obligations can use for these purposes without replacement;</li>\n' +
					"    <li>Coordinates employees' leave with school holidays;</li>\n" +
					'    <li>Introduces days for the children of employees to socialize, with a special emphasis on the children of male employees;</li>\n' +
					'    <li>Encourages active fatherhood among its employees.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Nagrajevanje in napredovanje') {
				return (
					'<p><strong>Manager can:</strong></p>\n' +
					'<ul>\n' +
					'    <li>Develops a culture of giving gifts to parents of newborns;</li>\n' +
					'    <li>Organizes activities that can benefit employees and their family members;</li>\n' +
					'    <li>Introduces a contribution for parents of school children in the form of a scholarship;</li>\n' +
					'    <li>Introduces loans and financial assistance for employees;</li>\n' +
					'    <li>Adopts an appropriate act that would define the possibilities of rewards and incentives at the macro level;</li>\n' +
					'    <li>In terms of promotion, takes into account the principle of gender equality and the various forms of care obligations of employees.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Informiranje in komuniciranje') {
				return (
					'<p><strong>Manager can:</strong></p>\n' +
					'<ul>\n' +
					"    <li>Prepares an information handout/leaflet to inform employees about organization's measures that promote work-life balance;</li>\n" +
					'    <li>Conducts an annual survey among employees about their satisfaction with achieving work-life balance;</li>\n' +
					'    <li>Introduces the area of work-life balance into the annual interview with employees;</li>\n' +
					'    <li>Establish a "suggestion box" in the company, with which they would take care of communicating the (dis)satisfaction of employees.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Zadovoljstvo na delovnem mestu') {
				return (
					'<p><strong>Manager can:</strong></p>\n' +
					'<ul>\n' +
					'    <li>Introduces a development coffee for their employees, the aim of which is to invite employees to a coffee, accompanied by information sharing and communication;</li>\n' +
					'    <li>Introduces co-financing of various activities of employees in their free time;</li>\n' +
					'    <li>Introduces a social corner/room in the organization for employees;</li>\n' +
					"    <li>Introduces New Year's gifts for employees' children;</li>\n" +
					'    <li>Develop a culture of giving gifts to parents of newborns.</li>\n' +
					'</ul>'
				);
			}

			if (activeSection === 'Delovni čas in organizacija dela') {
				return (
					'<p><strong>Manager can introduce:</strong></p>\n' +
					'<ul>\n' +
					'    <li>Flexible working hours;</li>\n' +
					'    <li>Sliding working hours;</li>\n' +
					'    <li>Work from home;</li>\n' +
					"    <li>Work outside the employer's premises;</li>\n" +
					'    <li>Flexible shift work;</li>\n' +
					'    <li>The possibility of part-time work;</li>\n' +
					'    <li>Hybrid work;</li>\n' +
					'    <li>The right to disconnect.</li>\n' +
					'</ul>'
				);
			}
		}

		return '';
	};

	const colSpanFor = (index: number) => {
		const rr = index % 7;

		if (props.type === 2) {
			if (rr === 0) {
				return 6;
			}
			if (rr === 1) {
				return 6;
			}
			if (rr === 2) {
				return 12;
			}
		}

		if (rr === 0) {
			return 6;
		}
		if (rr === 1) {
			return 6;
		}
		if (rr === 2) {
			return 7;
		}
		if (rr === 3) {
			return 5;
		}
		if (rr === 4) {
			return 6;
		}
		if (rr === 5) {
			return 6;
		}
		if (rr === 6) {
			return 12;
		}
		if (rr === 7) {
			return 12;
		}
		return 12;
	};

	const [showw, setShoww] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			return setShoww(true);
		}, Math.random() * 400 + 200);
	}, []);

	const isMobileWidth = document.body.clientWidth < 768;
	const wdth = isMobileWidth ? '65%' : '200%';
	const mleft = isMobileWidth ? '0px' : '-100%';

	return (
		<>
			{!showw && <FullPageLoadingComponent />}
			<div
				className={`grid grid-cols-12 gap-12 relative h-fit transition-all z-1000 ${
					showw ? 'opacity-100' : 'opacity-0'
				}`}
				style={{
					maxHeight: showw ? '100vh' : '0px',
				}}
			>
				<div
					className={`col-span-12 duration-300 bg-white p-8 pb-12 ${
						activeSection === undefined
							? '-translate-x-full opacity-0'
							: 'translate-x-0 opacity-100'
					}`}
					style={{
						width:
							activeSection === 'Skrbstveno delo' ? '100%' : wdth,
						marginLeft: [
							'Informiranje in komuniciranje',
							'Delovni čas in organizacija dela',
							'Veščine vodstva',
							'Skrbstveno delo',
						].includes(activeSection)
							? '0%'
							: mleft,
						zIndex: 1000,
						position: 'relative',
					}}
				>
					<div
						className={`transform transition ${
							slideOut
								? '-translate-x-24 opacity-0'
								: 'translate-x-0 opacity-100'
						}`}
					>
						<img
							src={multiarrows}
							alt={''}
							className={'h-12 mx-auto mb-4'}
						/>
						<div
							className={
								'text-center flex justify-center flex-col gap-0 msrs text-base'
							}
							dangerouslySetInnerHTML={{
								__html: getSectionContent(),
							}}
						/>
					</div>
				</div>
			</div>
		</>
	);
}

export default function LeadersInOrg() {
	const { t } = useI18n();

	// onmount
	React.useEffect(() => {
		// go to #id if present in url
		const hash = window.location.hash;
		if (hash) {
			const id = hash.replace('#', '');
			const element = document.getElementById(id);
			if (element) {
				window.scrollTo({
					top: element.offsetTop + 45,
				});
			}
		}
	}, []);

	const [activeSection, setActiveSection] = useState<string>('');

	return (
		<>
			<div
				className={
					'bg-white w-full text-center text-2xl py-4 mb-8 md:mb-24'
				}
			>
				{getLocaledString(
					'Kako lahko kot vodja prispevam k lažjemu usklajevanju poklicnega in zasebnega življenja zaposlenih?',
					'How can I contribute to better work-life balance of employees?',
				)}
			</div>
			<div
				style={{ height: 'calc(100vh - 410px)' }}
				className={
					'relative hidden md:flex justify-center items-center flex-col pb-28'
				}
			>
				{/* People */}
				<div className={'max-w-8xl px-6 md:px-12 mx-auto relative'}>
					<img src={folk} alt={''} />
					<div className={'absolute top-0 left-0 ml-64 -mt-16'}>
						<div className={'bubble left text-lg'}>
							{getLocaledString(
								'Zakaj je pomembno, da kot vodja spodbujam zaposlene k uspešnemu usklajevanju poklicnega in zasebnega življenja z različnimi ukrepi?',
								'Why is it important that, as a manager, I encourage employees to successfully balance their professional and private lives through various measures?',
							)}
						</div>
					</div>
					<div className={'absolute -bottom-32 right-52'}>
						<div className={'bubble right text-lg'}>
							{getLocaledString(
								'Ker je to super tako za zaposlene kot za podjetje! Zaposleni in zaposlene bodo slišani in posledično zadovoljni ter bolj produktivni, podjetje pa bo uživalo dober sloves in privlačilo nove talente.',
								"Because it's great for both the employees and the company! Employees will be heard and consequently satisfied and more productive, and the company will enjoy a good reputation and attract new talent.",
							)}
						</div>
					</div>
				</div>
			</div>

			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 md:mt-16 text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				{getLocaledString('Abeceda', 'Dictionary')}
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 mb-8 md:mb-0'
				}
			>
				<div className={'flex flex-col md:flex-row gap-12'}>
					<div
						className={
							'mb-1 flex justify-start items-center flex-col gap-0 text-center flex-1'
						}
					>
						<img
							src={qstn}
							alt={''}
							className={'md:w-16 w-10 text-lg mb-4'}
						/>
						<div className={'md:px-16 text-lg'}>
							{getLocaledString(
								'Kaj sploh je usklajevanje poklicnega in zasebnega življenja? S katerimi drugimi koncepti in pojmi se povezuje?',
								'What exactly is work-life balance? What other concepts is it associated with?',
							)}
						</div>
						<div className={'bg-white font-bold p-4 mt-4'}>
							{getLocaledString(
								'Abeceda služi kot podlaga za celovito razumevanje tematike. Prelistaj jo in spoznaj razsežnosti, ki jih koncept usklajevanja zasebnega in poklicnega življenja zajema.',
								'The dictionary serves as a basis for a comprehensive understanding of the concept of work-life balance. Flip through it and get to know the dimensions that the concept covers.',
							)}
						</div>
						<div className={'p-8 -mt-2'}>
							{getLocaledString(
								'Za boljše razumevanje vpliva spolnih stereotipov in z njimi povezanih spolnih vlog na (ne)zmožnost usklajevanja poklicnega in zasebnega življenja ti priporočamo tole platformo',
								'For a better understanding of the impact of gender stereotypes and related gender roles on the (in)ability to balance professional and private life, we recommend this platform',
							)}{' '}
							<Link
								to={
									'https://end-gender-stereotypes.campaign.europa.eu/work-life-balance_sl'
								}
								className={'underline text-lg'}
							>
								({getLocaledString('KLIK', 'CLICK')})
							</Link>
							.
						</div>
					</div>
					<div className={'flex-1'}>
						<FlipComponent />
					</div>
				</div>
			</div>

			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 md:mt-16 text-lg text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				<h5 id={'izhodisce'}>
					{getLocaledString(
						'MOJA IZHODIŠČNA TOČKA?',
						'STARTING POINT?',
					)}
				</h5>
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8'
				}
			>
				<div className={'flex flex-col m5-14'}>
					<div
						className={
							'mb-1 flex justify-start items-center flex-col gap-0 text-center md:px-52 relative mx-auto w-fit'
						}
					>
						{getLocaledString(
							'Pri naslavljanju kakršnihkoli izzivov je najpomembneje poznati lastno izhodiščno točko. Samo na ta način vemo kje točno se nahajamo in koliko korakov nas loči do končnega cilja.',
							'When addressing any challenges, the most important thing is to know your own starting point. Only this way we can know exactly where we are and how many steps separate us from our final destination.',
						)}
						<img
							src={pins}
							alt=""
							className={
								'absolute -top-4 right-28 w-24 opacity-20 md:opacity-100'
							}
						/>
					</div>
					<div
						className={
							'font-bold mt-10 text-center mx-auto relative w-fit'
						}
					>
						<img
							src={bulb}
							alt=""
							className={'absolute -top-4 -right-12 w-10'}
						/>
						{getLocaledString(
							'Uokviri svojo izhodiščno točko',
							'Frame your starting point',
						)}
					</div>
					<div className={'flex flex-col md:flex-row gap-4 mt-14'}>
						<div
							className={
								'flex-1 w-full h-96 bg-blue-faded flex justify-center items-center flex-col text-center'
							}
						>
							<Link
								to={'/quiz1'}
								className={
									'z-50 text-white text-shadow text-3xl relative w-full h-full group cursor-pointer py-5 md:py-0'
								}
							>
								<img
									src={bad}
									alt=""
									className={
										'absolute top-0 left-0 object-cover w-full h-full -z-10'
									}
								/>
								<div
									className={
										'bg-blue-faded w-full h-full z-10 absolute top-0 left-0'
									}
								/>
								<div
									className={
										'h-full w-full flex justify-center items-center flex-col'
									}
								>
									<div
										className={
											'transition font-bold z-20 transform scale-100 group-hover:scale-110'
										}
									>
										{getLocaledString('KVIZ', 'QUIZ')}
									</div>
									<div
										className={
											'transition text-2xl z-20 px-14 transform scale-100 group-hover:scale-110'
										}
									>
										{getLocaledString(
											'(Ne)uspešnost naslavljanja poklicnega in zasebnega življenja v organizaciji',
											'(Un)successful Addressal of Work-life Balance in My Organization',
										)}
									</div>
								</div>
							</Link>
						</div>
					</div>
					<div className={'flex flex-col md:flex-row gap-4 mt-4'}>
						<div
							className={
								'flex-1 text-center px-16 md:px-60 text-gray-700 italic text-sm'
							}
						>
							{getLocaledString(
								'Ali podjetje v katerem delam naslavlja in promovira usklajevanje poklicnega in zasebnega življenja? Kakšna orodja in politike so na voljo zaposlenim za dobro uravnoteženost poklicnih in zasebnih obveznosti?',
								'Does the company I work for address and promote the balance between professional and private life? What tools and policies are available to employees for a good balance of professional and private obligations?',
							)}
						</div>
					</div>
				</div>
			</div>

			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 mt-16 text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				<h5 id={'dosegsprememb'}>
					{getLocaledString(
						'UKREPI ZA DOSEGANJE SPREMEMB',
						'MEASURES',
					)}
				</h5>
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 text-center'
				}
			>
				<div className={'mb-8'}>
					{getLocaledString(
						'Izredno pomembno je, da si z drugimi zaposlenimi in vodstvom naše organizacije delimo vsaj nekatere aspekte vizije, kaj pomeni uspešno usklajevanje poklicnega in zasebnega življenja. Preglej ukrepe v treh vsebinskih sklopih in z malce poguma ter volje spodbudi sodelavce in sodelavke k dosegljivim spremembam.',
						'It is extremely important that we share at least some aspects of the vision of what successful work-life balance means with other employees and the management of our organization. Review the measures in the three thematic clusters and with a bit of courage and will, encourage your colleagues to make achievable changes.',
					)}
				</div>

				<div className={'flex justify-center items-center flex-col'}>
					<div className={'flex flex-col h-full w-full'}>
						<div className={'h-full flex flex-col md:flex-row'}>
							<div className={'flex-1 relative w-full'}>
								<div
									className={
										'flex-1 relative w-full h-96 overflow-hidden'
									}
								>
									<div
										className={
											'w-full h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-3xl justify-center items-center flex flex-col'
										}
										onClick={() => {
											setActiveSection(
												activeSection ===
													'Informiranje in komuniciranje'
													? ''
													: 'Informiranje in komuniciranje',
											);
										}}
									>
										{getLocaledString(
											'Informiranje in komuniciranje',
											'Communication',
										)}
									</div>
									<img
										src={pxls1}
										alt=""
										className={
											'absolute top-0 left-0 w-full h-full object-cover'
										}
									/>
								</div>
								<div>
									{activeSection ===
										'Informiranje in komuniciranje' && (
										<>
											<MeasureSections
												activeSection={activeSection}
												type={1}
											/>
										</>
									)}
								</div>
							</div>
							<div className={'flex-1 relative w-full'}>
								<div
									className={
										'flex-1 relative w-full h-96 overflow-hidden'
									}
								>
									<div
										className={
											'w-full h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-3xl justify-center items-center flex flex-col'
										}
										onClick={() => {
											setActiveSection(
												activeSection ===
													'Zadovoljstvo na delovnem mestu'
													? ''
													: 'Zadovoljstvo na delovnem mestu',
											);
										}}
									>
										{getLocaledString(
											'Zadovoljstvo na delovnem mestu',
											'Job satisfaction',
										)}
									</div>
									<img
										src={pxls2}
										alt=""
										className={
											'absolute top-0 left-0 w-full h-full object-cover'
										}
									/>
								</div>
								<div>
									{activeSection ===
										'Zadovoljstvo na delovnem mestu' && (
										<>
											<MeasureSections
												activeSection={activeSection}
												type={1}
											/>
										</>
									)}
								</div>
							</div>
						</div>
						<div className={'h-full flex flex-col md:flex-row'}>
							<div className={'flex-1 relative w-full'}>
								<div
									className={
										'flex-1 relative w-full h-96 overflow-hidden'
									}
								>
									<div
										className={
											'w-full h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-3xl justify-center items-center flex flex-col'
										}
										onClick={() => {
											setActiveSection(
												activeSection ===
													'Delovni čas in organizacija dela'
													? ''
													: 'Delovni čas in organizacija dela',
											);
										}}
									>
										{getLocaledString(
											'Delovni čas in organizacija dela',
											'Work hours organization',
										)}
									</div>
									<img
										src={pxls8}
										alt=""
										className={
											'absolute top-0 left-0 w-full h-full object-cover'
										}
									/>
								</div>
								<div>
									{activeSection ===
										'Delovni čas in organizacija dela' && (
										<>
											<MeasureSections
												activeSection={activeSection}
												type={1}
											/>
										</>
									)}
								</div>
							</div>
							<div className={'flex-1 relative w-full'}>
								<div
									className={
										'flex-1 relative w-full h-96 overflow-hidden'
									}
								>
									<div
										className={
											'w-full h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-3xl justify-center items-center flex flex-col'
										}
										onClick={() => {
											setActiveSection(
												activeSection ===
													'Zaposlovanje in razvoj kadrov'
													? ''
													: 'Zaposlovanje in razvoj kadrov',
											);
										}}
									>
										{getLocaledString(
											'Zaposlovanje in razvoj kadrov',
											'Recruitment and development of personnel',
										)}
									</div>
									<img
										src={pxls6}
										alt=""
										className={
											'absolute top-0 left-0 w-full h-full object-cover'
										}
									/>
								</div>
								<div>
									{activeSection ===
										'Zaposlovanje in razvoj kadrov' && (
										<>
											<MeasureSections
												activeSection={activeSection}
												type={1}
											/>
										</>
									)}
								</div>
							</div>
						</div>
						<div className={'h-full flex flex-col md:flex-row'}>
							<div className={'flex-1 relative w-full'}>
								<div
									className={
										'flex-1 relative w-full h-96 overflow-hidden'
									}
								>
									<div
										className={
											'w-full h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-3xl justify-center items-center flex flex-col'
										}
										onClick={() => {
											setActiveSection(
												activeSection ===
													'Veščine vodstva'
													? ''
													: 'Veščine vodstva',
											);
										}}
									>
										{getLocaledString(
											'Veščine vodstva',
											'Leadership skills',
										)}
									</div>
									<img
										src={pxls3}
										alt=""
										className={
											'absolute top-0 left-0 w-full h-full object-cover'
										}
									/>
								</div>
								<div>
									{activeSection === 'Veščine vodstva' && (
										<>
											<MeasureSections
												activeSection={activeSection}
												type={1}
											/>
										</>
									)}
								</div>
							</div>
							<div className={'flex-1 relative w-full'}>
								<div
									className={
										'flex-1 relative w-full h-96 overflow-hidden'
									}
								>
									<div
										className={
											'w-full h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-3xl justify-center items-center flex flex-col'
										}
										onClick={() => {
											setActiveSection(
												activeSection ===
													'Nagrajevanje in napredovanje'
													? ''
													: 'Nagrajevanje in napredovanje',
											);
										}}
									>
										{getLocaledString(
											'Nagrajevanje in napredovanje',
											'Rewarding and promotion',
										)}
									</div>
									<img
										src={pxls7}
										alt=""
										className={
											'absolute top-0 left-0 w-full h-full object-cover'
										}
									/>
								</div>
								<div>
									{activeSection ===
										'Nagrajevanje in napredovanje' && (
										<>
											<MeasureSections
												activeSection={activeSection}
												type={1}
											/>
										</>
									)}
								</div>
							</div>
						</div>
						<div className={'h-full flex flex-col md:flex-row'}>
							<div className={'flex-1 relative w-full'}>
								<div
									className={
										'flex-1 relative w-full h-96 overflow-hidden'
									}
								>
									<div
										className={
											'w-full h-full absolute bg-blue-faded cursor-pointer transform scale-100 transition hover:scale-110 shadow z-10 text-white text-3xl justify-center items-center flex flex-col'
										}
										onClick={() => {
											setActiveSection(
												activeSection ===
													'Skrbstveno delo'
													? ''
													: 'Skrbstveno delo',
											);
										}}
									>
										{getLocaledString(
											'Skrbstveno delo',
											'Care work',
										)}
									</div>
									<img
										src={pxls4}
										alt=""
										className={
											'absolute top-0 left-0 w-full h-full object-cover'
										}
									/>
								</div>
								<div>
									{activeSection === 'Skrbstveno delo' && (
										<>
											<MeasureSections
												activeSection={activeSection}
												type={1}
											/>
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 mt-16 text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				<h5 id={'dosegsprememb'}>
					{getLocaledString(
						'IZOBRAŽEVALNI MODULI',
						'EDUCATIONAL MODULES',
					)}
				</h5>
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 text-center'
				}
			>
				<div className={'bg-white p-4 font-bold text-xl'}>
					{getLocaledString(
						'Izobrazba je najpomembnejše orodje in ključ do uspeha!',
						'Education is the most important tool and key to success!',
					)}
				</div>
				<div className={'my-7 md:px-16 text-sm md:text-lg'}>
					{getLocaledString(
						'Izobraževalni moduli se lahko uporabljajo individualno, s sodelavci ali pa se predstavijo vodstvu organizacije s predlogom, da se jih vključi v naslednja strokovna izobraževanja. Vsak posameznik in posameznica lahko identificirata vsaj en relevanten modul, glede na svoje osebne okoliščine in z njimi povezane potrebe.',
						'The educational modules can be used individually, with colleagues or presented to the management of the organization with a proposal to include them in the next professional trainings. Each individual can identify at least one relevant module, based on their personal circumstances and related needs.',
					)}
				</div>
				<div className={'my-7 md:px-16 text-sm md:text-lg'}>
					{getLocaledString(
						'Za celovit pregled pedagoških pristopov in poglobljeno razumevanje izobraževalnih modulov predlagamo prenos Kataloga izobraževalnih modulov',
						'For a comprehensive overview of pedagogical approaches and a deeper understanding of educational modules, we suggest downloading the Catalog of Educational Modules',
					)}{' '}
					<a
						className={'underline inline-flex'}
						href={
							appstate.currentLanguage() === 'slSI'
								? `https://projekt-prometej.si/EducationalModulesCatalog.pdf`
								: `https://projekt-prometej.si/EducationalModulesCatalogEnglish.pdf`
						}
						target={'_blank'}
						rel="noreferrer"
					>
						({getLocaledString('KLIK', 'CLICK')})
					</a>
					.
				</div>
				<ModulesView />
			</div>

			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 mt-16 text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				<h5 id={'dosegsprememb'}>
					{getLocaledString('KAM PO POMOČ?', 'WHERE CAN I GET HELP?')}
				</h5>
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 text-center'
				}
			>
				<div
					className={
						'relative hidden md:flex justify-center items-center flex-col pb-28'
					}
				>
					{/* People */}
					<div
						className={
							'max-w-8xl px-6 md:px-12 mx-auto relative mt-2'
						}
					>
						<img src={folk2} alt={''} />
						<div className={'absolute top-0 left-0 ml-64 -mt-12'}>
							<div className={'bubble left text-lg'}>
								{getLocaledString(
									'Kam oziroma h komu se lahko kot vodja še obrnem za pomoč pri razumevanju in naslavljanju poklicnega in zasebnega življenja?',
									"Where or whom can I turn to as a manager for help in understanding employees' needs in relation to work-life balance? ",
								)}
							</div>
						</div>
						<div className={'absolute -bottom-36 right-48'}>
							<div className={'bubble right text-lg'}>
								{getLocaledString(
									'Obstaja ogromno združenj in organizacij, ki višajo ozaveščenost o tematiki, dodatno pa še izvajajo usposabljanja za zaposlene in vodje, preverjajo obstoječe stanje v organizaciji in podeljujejo različne certifikate.',
									'There are a lot of organizations that raise awareness about the importance of work-life balance, and additionally conduct training for employees and managers or award various certificates.',
								)}
							</div>
						</div>
					</div>
				</div>

				<div className={'mt-12'}>
					<KeyOrgsView />
				</div>
			</div>
			<div className={'h-14'} />
			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 mt-16 text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				<h5 id={'dosegsprememb'}>
					{getLocaledString(
						'VČASIH POTREBUJEMO MALCE NAVDIHA...',
						'SOMETIMES WE NEED A LITTLE INSPIRATION...',
					)}
				</h5>
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 text-center'
				}
			>
				<div className={'mt-4'}>
					{appstate.currentLanguage() === 'sl' ? (
						<>
							<b>Podcast</b> je odlično orodje za učenje,
							premišljevanje in doseganje miselnih napredkov.
							Naslednji strokovnjaki s svojim delom navdihujejo
							ljudi za doseganje želenih sprememb v poklicnem in
							zasebnem življenju.
						</>
					) : (
						<>
							A <b>podcast</b> is a great tool for learning,
							reflecting and achieving minor or major mental
							breakthroughs. The following experts use their work
							to inspire people to achieve the desired changes in
							their professional and private lives.
						</>
					)}
				</div>
				<div className={'flex flex-col md:flex-row gap-12 py-8'}>
					<div
						className={
							'flex-1 text-justify relative flex justify-center items-center md:py-16 text-lg'
						}
					>
						<img
							src={sss}
							alt=""
							className={
								'absolute top-0 left-0 h-full w-full object-cover z-10'
							}
						/>
						<div
							className={
								'bg-blue-faded w-full h-full absolute top-0 left-0 z-20'
							}
						/>
						<div
							className={
								'flex flex-col gap-6 mt-3 z-50 relative text-3xl text-center text-white text-shadow '
							}
						>
							<a
								href={
									'https://recognation.com/a-podcast-for-people-leaders-everywhere/'
								}
								target={'_blank'}
								className={'underline text-lg md:text-3xl'}
								rel="noreferrer"
							>
								The RecogNATION
							</a>
							<a
								href={
									'https://podcasts.apple.com/us/podcast/engaging-people-podcast/id1093486834'
								}
								target={'_blank'}
								className={'underline text-lg md:text-3xl'}
								rel="noreferrer"
							>
								{/* eslint-disable-next-line react/no-unescaped-entities */}
								Engaging People
							</a>
							<a
								href={
									'https://stickyfromtheinside.podbean.com/'
								}
								target={'_blank'}
								className={'underline text-lg md:text-3xl'}
								rel="noreferrer"
							>
								The Sticky from the Inside
							</a>
							<a
								href={'https://tec-podcast.com/'}
								target={'_blank'}
								className={'underline text-lg md:text-3xl'}
								rel="noreferrer"
							>
								Engaging People, Powering Companies
							</a>
							<a
								href={
									'https://podcasts.apple.com/us/podcast/the-positive-leadership-movement/id1481215985'
								}
								target={'_blank'}
								className={'underline text-lg md:text-3xl'}
								rel="noreferrer"
							>
								The Positive Leadership Movement
							</a>
						</div>
					</div>
				</div>
			</div>

			<div
				className={
					'is-kazalo-title bg-white w-full text-center text-3xl py-7 mt-16 text-white font-bold uppercase'
				}
				style={{ background: '#424459' }}
			>
				<h5 id={'dosegsprememb'}>
					{getLocaledString(
						'MENTORSTVO = PRENOS DOBRIH PRAKS',
						'MENTORING = TRANSFER OF GOOD PRACTICES',
					)}
				</h5>
			</div>
			<div
				className={
					'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 text-center'
				}
			>
				<div className={'flex flex-col md:flex-row gap-12 py-4'}>
					<a
						className={
							'flex-1 bg-blue-50 h-96 overflow-hidden relative flex justify-center items-center flex-col'
						}
						href={`https://projekt-prometej.si/new-prirocnik-${appstate.currentLanguage()}.pdf`}
						target={'_blank'}
						rel="noreferrer"
					>
						<img
							src={ggg}
							alt=""
							className={
								'w-full h-full object-cover absolute top-0 left-0'
							}
						/>

						<div
							className={
								'bg-blue-faded w-full h-full z-10 absolute top-0 left-0'
							}
						/>

						<div
							className={
								'relative z-20 text-white text-3xl text-shadow py-16 md:py-0'
							}
						>
							{getLocaledString(
								'Prenesi priročnik',
								'Download the handbook',
							)}
						</div>
					</a>
					<div
						className={
							'flex-1 flex justify-center items-center flex-col'
						}
					>
						<div>
							{getLocaledString(
								'Mentorstvo je dragoceno orodje, ki lahko z doslednim in učinkovitim izvajanjem posameznikom pomaga pri napredovanju na določenih področjih. Med ta področja se uvršča tudi usklajevanje poklicnega in zasebnega življenja.',
								'Mentoring is a valuable tool that, with consistent and effective implementation, can help individuals advance in certain areas. These areas also include the coordination of professional and private life.',
							)}
						</div>
						<div className={'text-center mt-4'}>
							{getLocaledString(
								'Za bolj učinkovito izobraževanje mentorjev smo pripravili Priročnik za učinkovito mentorstvo. V digitalni obliki ga razpošlji obstoječim in potencialnim mentorjem ter tako razširi pomen mentorstva v organizaciji!',
								'For more effective training of mentors, we have prepared the Handbook for effective mentoring. Distribute it in digital form to existing and potential mentors and thus expand the importance of mentoring in the organization!',
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
